import * as types from "./../types";

const beaureDemoData = {
  shortCode: "",
  invalidOtpAttemptCount: 0,
  panNumber: "",
  dob: "",
  nameOnCard: "",
  nameMatchFlag: null,
  dobMatchFlag: null,
  gender: "",
  resiCity: "",
  landmark: "",
  officeAddr: [],
  resiAddr: [],
  signedValue: "",
  panGender: "",
  visionMothersName: "",
  visionEmailId: "",
  visionAddress: [],
  dSignVPlusMotherName: "",
  dSignVPlusEmailId: "",
  dSignVPlusResiAddress: "",
  multicardUrl: "",
  cureAfterDate: "",
  applicationUpdatedDate: "",
  applicationNumber: "",
  applicationStatus: "",
  hsToken: "",
};

const ckycData = {
  shortCode: "",
  gender: "",
  digilockerUrl: "",
  applicationNumber: "", //Added for iphone testing to be removed once testing completes
  kin: "",
  resiAddr: [],
  ckycOtpGenRequestId: ""
};


const initState = {
  sslUpdateData: null,
  ckycData: null,
  error: null,
  partnerData: null,
};

const SslReducer = (state = initState, action) => {
  switch (action.type) {
    case types.CLEAR_SSL_DATA:
      return {
        ...state,
        sslUpdateData: beaureDemoData,
      };
    case types.VALIDATE_OTP_CREATE_SSL:
      return {
        ...state,
        sslUpdateData: {
          ...beaureDemoData,
          shortCode: action.payload.data?.shortCode,
          invalidOtpAttemptCount: action.payload.data?.invalidOtpAttemptCount,
          panNumber: action.payload.data?.panNumber,
          dob: action.payload.data?.dob,
          nameOnCard: action.payload.data?.nameOnCard,
          nameMatchFlag: action.payload.data?.nameMatchFlag,
          dobMatchFlag: action.payload.data?.dobMatchFlag,
          gender: action.payload.data?.gender,
          resiCity: action.payload.data?.city,
          landmark: action.payload.data?.landmark,
          officeAddr: action.payload.data?.officeAddr,
          resiAddr: action.payload.data?.resiAddr,
          signedValue: action.payload.data?.signedValue,
          hsToken: action.payload.data?.hsToken,
          //submitAction: action.payload.data?.submitAction,
        },
        error: action.payload?.error,
      };
    case types.SAVE_CKYC_DATA:
      return {
        ...state,
        ckycData: {
          ...ckycData,
          shortCode: action.payload?.shortCode,
          gender: action.payload?.gender,
          digilockerUrl: action.payload?.digilockerUrl,
          applicationNumber: action.payload?.applicationNumber,
          resiAddr: action.payload?.resiAddr,
          kin: action.payload?.kin,
        },
        error: action.payload?.error,
      };
    case types.SAVE_CKYC_KIN_NUMBER :
      return {
        ...state,
        ckycData:{
          ...state.ckycData,
          kin : action?.payload?.kinNumber,
          ckycOtpGenRequestId : action?.payload?.ckycOtpGenRequestId,
        }
      }

    case types.SAVE_SSL_VAL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case types.SAVE_MULTURL_DATA:
      return {
        ...state,
        sslUpdateData: {
          // ...beaureDemoData,
          ...state.sslUpdateData,
          multicardUrl: action.payload?.multicardUrl,
          panGender: action.payload?.gender,
          cureAfterDate: action.payload?.cureAfterDate,
          applicationUpdatedDate: action.payload?.applicationUpdatedDate,
          applicationNumber: action.payload?.applicationNumber,
          applicationStatus: action.payload?.applicationStatus,
          hsToken: action.payload?.hsToken,
        },
      };

    case types.SAVE_VISION_DATA:
      return {
        ...state,
        sslUpdateData: {
          ...beaureDemoData,
          // ...state.sslUpdateData,
          multicardUrl: action.payload?.multicardUrl,
          panGender: action.payload?.gender,
          cureAfterDate: action.payload?.cureAfterDate,
          applicationUpdatedDate: action.payload?.applicationUpdatedDate,
          applicationNumber: action.payload?.applicationNumber,
          applicationStatus: action.payload?.applicationStatus,
          hsToken: action.payload?.hsToken,
          visionAddress: action.payload?.vPlusResiAddress,
          visionMothersName: action.payload?.visionMothersName,
          visionEmailId: action.payload?.visionEmailId,
          dSignVPlusMotherName: action.payload?.dSignVPlusMotherName,
          dSignVPlusEmailId: action.payload?.dSignVPlusEmailId,
          dSignVPlusResiAddress: action.payload?.dSignVPlusResiAddress
        },
      };

    case types.SAVE_PARTNER_DATA:
      return {
        ...state,
        partnerData: {
          ...state.partnerData,
          channelCode: action.payload?.channelCode,
          contactDetails: action.payload?.contactDetails,
          inbmitcScreen: action.payload?.inbmitcScreen,
          autoSweepReceived: action.payload?.autoSweepReceived,
          autoDebitReceived: action.payload?.autoDebitReceived,
          paymentOption: action.payload?.paymentOption,
          blazeAdFlag: action.payload?.blazeAdFlag,
          blazeAsFlag: action.payload?.blazeAsFlag,
          accNoOnAutoDebit: action.payload?.accNoOnAutoDebit,
          platformIndicator: action.payload?.platformIndicator,
          inbFlag: action.payload?.inbFlag,
          partnerUUID: action.payload?.partnerUUID,
          yonoUUID: action.payload?.yonoUUID,
          fdAccountNo: action.payload?.fdAccountNo,
          savingsAccountNo: action.payload?.savingsAccountNo,
          holdAmount: action.payload?.holdAmount,
        },
        error: action.payload?.error,
      };
    default:
      return state;
  }
};

export default SslReducer;
